/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_PrecinctGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for PrecinctGroups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, September 29, 2019 - 08:26:08 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/29/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PRECINCTGROUP_LIST_CONTAINER_LOADED,
    PRECINCTGROUP_LIST_CONTAINER_UNLOADED,
    PRECINCTGROUP_LIST_TABLE_LOADED,
    PRECINCTGROUP_LIST_TABLE_UNLOADED,

    PRECINCTGROUP_SELECT_ROW,
    PRECINCTGROUP_ADD,
    PRECINCTGROUP_EDIT,
    PRECINCTGROUP_DELETE,
    PRECINCTGROUP_OPEN_WARNING,
    PRECINCTGROUP_CLOSE_WARNING,
    PRECINCTGROUP_DELETE_DISABLE,

    PRECINCTGROUP_EDIT_CONTAINER_LOADED,
    PRECINCTGROUP_EDIT_CONTAINER_UNLOADED,
    PRECINCTGROUP_EDIT_FORM_LOADED,
    PRECINCTGROUP_EDIT_FORM_UNLOADED,
    PRECINCTGROUP_EDIT_DATA_LOAD,
    PRECINCTGROUP_EDIT_CONTAINER_SUBMIT,
    PRECINCTGROUP_EDIT_CONTAINER_CANCEL,
    PRECINCTGROUP_UPDATE_VALUE
} from '../constants/actionTypeGoCampaign_PrecinctGroups';

const defaultState = {
    refreshList: false,
    danger: false,
    precinctgroupid: 0,
    countryid: 0,
    stateid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PRECINCTGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                precinctgroups: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
            }
        case PRECINCTGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PRECINCTGROUP_SELECT_ROW:
            return {
                ...state,
                precinctgroupid: action.id
            }
        case PRECINCTGROUP_ADD:
            return {
                ...state
            }
        case PRECINCTGROUP_EDIT:
            return {
                ...state,
                precinctgroupid: action.id
            }
        case PRECINCTGROUP_DELETE:
            return {
                ...state,
                precinctgroupid: null
            }
        case PRECINCTGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case PRECINCTGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PRECINCTGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PRECINCTGROUP_EDIT_CONTAINER_LOADED:
        case PRECINCTGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                precinctgroupid: action.payload[0] ? action.payload[0].precinctgroupid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PRECINCTGROUP_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case PRECINCTGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PRECINCTGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PRECINCTGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PRECINCTGROUP_LIST_CONTAINER_UNLOADED:
        case PRECINCTGROUP_LIST_TABLE_UNLOADED:
        case PRECINCTGROUP_EDIT_CONTAINER_UNLOADED:
        case PRECINCTGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_PrecinctGroups.js